var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 161,
    viewBox: "0 0 247 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_11980)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6174,
    y: 8.5625,
    width: 91.1429,
    height: 56.5714,
    rx: 11,
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.7604,
    cy: 93.4188,
    r: 9.42857,
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9796 83.0988L44.0616 80.8477L34.0486 93.8267L29.9758 90.4647L27.689 93.2349L33.9744 98.4234L34.0358 98.349L34.7747 98.9191L46.9796 83.0988Z",
    fill: "#49A372"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.6173,
    cy: 93.4188,
    r: 9.42857,
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.8365 83.0988L73.9185 80.8477L63.9056 93.8267L59.8327 90.4647L57.5459 93.2349L63.8313 98.4234L63.8927 98.349L64.6316 98.9191L76.8365 83.0988Z",
    fill: "#49A372"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.2604,
    cy: 93.4188,
    r: 9.42857,
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.48 83.0988L104.562 80.8477L94.5486 93.8267L90.4758 90.4647L88.189 93.2349L94.4744 98.4234L94.5358 98.349L95.2747 98.9191L107.48 83.0988Z",
    fill: "#49A372"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4031 16.4199H99.9745",
    stroke: "#9CABBD",
    strokeWidth: 3.14286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4031 25.0625H99.9745",
    stroke: "#9CABBD",
    strokeWidth: 3.14286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4031 33.7051H99.9745",
    stroke: "#9CABBD",
    strokeWidth: 3.14286,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.686,
    cy: 49.686,
    r: 6.186,
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.686,
    cy: 49.686,
    r: 6.186,
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 94.686,
    cy: 49.686,
    r: 6.186,
    stroke: "#9CABBD",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.054 33.1065C229.913 53.3533 203.73 88.0107 185.531 102.809L177.166 88.2873C209.571 69.7001 196.245 49.8405 185.531 42.2341L165.718 33.1065L172.322 24.8086L189.054 33.1065Z",
    fill: "#7E868F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.718,
    y: 114.809,
    width: 84.8571,
    height: 22,
    rx: 7.07143,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.575,
    y: 113.236,
    width: 91.9286,
    height: 7.07143,
    rx: 3.53571,
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.575,
    y: 113.236,
    width: 91.9286,
    height: 7.07143,
    rx: 3.53571,
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.575,
    y: 120.309,
    width: 91.9286,
    height: 7.07143,
    rx: 3.53571,
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.575,
    y: 120.309,
    width: 91.9286,
    height: 7.07143,
    rx: 3.53571,
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.244 90.0589C177.756 87.4398 181.537 87.4398 183.049 90.0589L193.936 108.916C195.448 111.535 193.558 114.809 190.534 114.809H168.759C165.735 114.809 163.845 111.535 165.357 108.916L176.244 90.0589Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.218,
    y: 85.7363,
    width: 44,
    height: 6.28571,
    rx: 3.14286,
    fill: "#929292"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.861,
    y: 92.0234,
    width: 24.3571,
    height: 6.28571,
    rx: 3.14286,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.375,
    y: 10.3086,
    width: 14.9286,
    height: 60.5,
    rx: 6.28571,
    transform: "rotate(39.6264 177.375 10.3086)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.245,
    y: 4.80859,
    width: 25.7507,
    height: 6.80852,
    rx: 3.40426,
    transform: "rotate(40.8761 176.245 4.80859)",
    fill: "#CB9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.245,
    y: 4.80859,
    width: 25.7507,
    height: 6.80852,
    rx: 3.40426,
    transform: "rotate(40.8761 176.245 4.80859)",
    fill: "#CB9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.245,
    y: 4.80859,
    width: 25.7507,
    height: 6.80852,
    rx: 3.40426,
    transform: "rotate(40.8761 176.245 4.80859)",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.959,
    y: 15.8086,
    width: 36.8838,
    height: 8.60328,
    rx: 4.30164,
    transform: "rotate(40.8761 158.959 15.8086)",
    fill: "#CB9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.959,
    y: 15.8086,
    width: 36.8838,
    height: 8.60328,
    rx: 4.30164,
    transform: "rotate(40.8761 158.959 15.8086)",
    fill: "#CB9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.959,
    y: 15.8086,
    width: 36.8838,
    height: 8.60328,
    rx: 4.30164,
    transform: "rotate(40.8761 158.959 15.8086)",
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.468,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.468,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.468,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.825,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.825,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.825,
    cy: 110.488,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.964,
    cy: 50.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.964,
    cy: 50.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.964,
    cy: 50.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.964,
    cy: 54.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.964,
    cy: 54.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.964,
    cy: 54.9643,
    r: 1.96429,
    fill: "#777777"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.332,
    y: 50.1465,
    width: 19.0823,
    height: 6.97113,
    rx: 3.48557,
    transform: "rotate(40.4553 141.332 50.1465)",
    fill: "#66747D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 130,
    width: 189,
    height: 23,
    rx: 5,
    fill: "#30324D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 130,
    width: 189,
    height: 13,
    rx: 5,
    fill: "#424460"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.922,
    y: 43.252,
    width: 8,
    height: 15.0907,
    transform: "rotate(-50.0325 149.922 43.252)",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_11980",
    x: -4,
    y: 0,
    width: 255,
    height: 161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_11980"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_11980",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchImage);
export default __webpack_public_path__ + "static/media/research-image.9505c96b783ace8c917b354313ec8735.svg";
export { ForwardRef as ReactComponent };